import { ActionItem } from '../../gs-component-form';
import { RouterContext } from '../../gs-component-right-rail';
import { InlineAlert } from '@xo-union/tk-component-alerts';
import { ArrayHelpers, FieldArray, FormikProps } from 'formik';
import React, { useContext, useMemo } from 'react';

import { EventItem } from '../components/EventItem';
import RightRailSection from '../components/RightRailSection';
import { SoEInitialValues } from './ScheduleOfEventsForm';
import { emptySubEvent } from './helpers';

interface Props {
  formProps: FormikProps<SoEInitialValues>;
}

export const EventsList: React.FC<Props> = ({ formProps }) => {
  const { values, errors } = formProps;
  const { push } = useContext(RouterContext);

  const missingInfo = useMemo(() => {
    if (errors && errors.subEvents) {
      // @ts-ignore
      return errors.subEvents.every(se => se && (se.name || se.time));
    }
    return false;
  }, [errors]);

  return (
    <RightRailSection name="Event Schedule">
      {missingInfo && (
        <InlineAlert type="error">Please provide a name &amp; start time for all Schedule Items.</InlineAlert>
      )}

      <FieldArray name="subEvents">
        {(arrayHelpers: ArrayHelpers): JSX.Element => {
          return (
            <>
              {values &&
                Array.isArray(values.subEvents) &&
                values.subEvents.map((event, index) => (
                  <EventItem
                    key={`${event.name}-${event.id || index}`}
                    name={event.name}
                    time={event.time}
                    type={event.type}
                    endTime={event.endTime}
                    venueName={event.location && event.location.name}
                    onClick={(): void =>
                      push({
                        screen: 'scheduleItem',
                        params: {
                          index,
                          remove: arrayHelpers.remove,
                        },
                      })
                    }
                  />
                ))}
              <ActionItem
                type="add"
                onClick={(): void => {
                  arrayHelpers.push(emptySubEvent);
                  push({
                    screen: 'scheduleItem',
                    params: {
                      newItem: true,
                      index: values.subEvents.length,
                      remove: arrayHelpers.remove,
                    },
                  });
                }}
              >
                Add an Item to the Schedule
              </ActionItem>
            </>
          );
        }}
      </FieldArray>
    </RightRailSection>
  );
};
